/**
 * TaxReport — placeholder. Will host tax declarations & downloadable reports.
 */
import DashboardHeader from '../../components/DashboardHeader';
import BreadcrumbNav from '../../components/BreadcrumbNav';
import { useLanguage } from '../../context/LanguageContext';
import { FileBarChart2 } from 'lucide-react';

export default function TaxReport() {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const t = (ar, en) => (isAr ? ar : en);

  return (
    <div className="min-h-screen bg-[#030303] relative">
      <DashboardHeader showBackButton backPath="/dashboard/finance/vat" />
      <div className="border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <BreadcrumbNav items={[
            { label_ar: 'لوحة التحكم', label_en: 'Dashboard', path: '/dashboard' },
            { label_ar: 'المالية', label_en: 'Finance', path: '/dashboard/finance' },
            { label_ar: 'الضريبة المضافة', label_en: 'VAT', path: '/dashboard/finance/vat' },
            { label_ar: 'التقرير الضريبي', label_en: 'Tax Report', path: null },
          ]} />
        </div>
      </div>
      <main className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <div className="w-16 h-16 rounded-2xl bg-white/[0.02] border border-white/10 mx-auto mb-4 flex items-center justify-center">
          <FileBarChart2 className="w-8 h-8 text-white/40" />
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
          {t('التقرير الضريبي', 'Tax Report')}
        </h1>
        <p className="text-white/50 text-sm max-w-lg mx-auto">
          {t('التقارير والإقرارات الضريبية ستكون متاحة قريباً. ستشمل تصدير Excel/PDF، وتفصيل الضريبة المحصّلة لكل منصة، وتوليد إقرارات ربع سنوية.',
             'Tax reports and declarations will be available soon. It will include Excel/PDF export, per-platform VAT breakdown, and quarterly declaration generation.')}
        </p>
      </main>
    </div>
  );
}
